import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { MessageType } from '../../../../model/message.model';
import { BehaviorDataService } from '../../../../service/behaviorData.service';
import { MessageComponent } from '../../../../shared/components/messages/message-component';

@Component({
    selector: 'app-bottom-messages',
    templateUrl: 'bottom-messages.component.html',
    imports: [MessageComponent, TranslateModule],
})
export class BottomMessageComponent implements OnInit, OnDestroy {
    private behaviorData = inject(BehaviorDataService);

    purchaseLimitsErrorDetails: any;
    rgLimitsErrorDetails: any;
    instrumentDepositLimitErrorDetails: any;
    subscriptions$: Subscription[] = [];

    public get messageType(): typeof MessageType {
        return MessageType;
    }

    ngOnInit(): void {
        this.subscriptions$.push(
            this.behaviorData.getPurchaseLimitsErrorDetails.subscribe((data) => {
                this.purchaseLimitsErrorDetails = data;
            }),
        );

        this.subscriptions$.push(
            this.behaviorData.getRgLimitsErrorDetails.subscribe((data) => {
                this.rgLimitsErrorDetails = data;
            }),
        );

        this.subscriptions$.push(
            this.behaviorData.getInstrumentDepositLimitErrorDetails.subscribe((data) => {
                this.instrumentDepositLimitErrorDetails = data;
            }),
        );
    }

    ngOnDestroy() {
        this.subscriptions$.map((subscription) => subscription.unsubscribe());
    }
}
